<div class="modal-with-one-select-container">
  <div class="header-container">
    <h2>{{ 'medicalHistory.medicalNewRecordModal.add' | translate }} {{ 'medicalHistory.medicalNewRecordModal.' + data.key | translate }}</h2>
    <p>
      {{ 'medicalHistory.medicalNewRecordModal.insert_here' | translate }} {{ 'medicalHistory.medicalNewRecordModal.' + data.key | translate }}
      {{ 'medicalHistory.medicalNewRecordModal.and_date' | translate }}
    </p>
  </div>

  <form [formGroup]="formModal">
    <div class="pathology" *ngIf="data.key === 'pathology' || data.key === 'surgical'">
      <div nz-row>
        <ds-select
          nz-col
          nzXs="24"
          nzSm="24"
          nzMd="12"
          nzLg="12"
          nzXl="12"
          [placeholder]="'medicalHistory.medicalNewRecordModal.choose' | translate"
          [label]="'medicalHistory.medicalNewRecordModal.' + data.key | translate | titlecase"
          [texts]="modalOptions.texts"
          [values]="modalOptions.values"
          [control]="formModal.get('option')"
        ></ds-select>
      </div>
      <div>
        <div class="first-container">
          <div class="genere">
            <p>{{ 'medicalHistory.medicalNewRecordModal.genere' | translate}}</p>
            <span>{{ details.gender }}</span>
          </div>
          <div>
            <p>{{ 'medicalHistory.medicalNewRecordModal.sistema' | translate}}</p>
            <span>{{ details.apparatus }}</span>
          </div>
        </div>
        <div class="second-container">
          <div class="organo-interno">
            <p>{{ 'medicalHistory.medicalNewRecordModal.internal_organ' | translate}}</p>
            <span>{{ details.organ }}</span>
          </div>
          <div>
            <p>{{ 'medicalHistory.medicalNewRecordModal.body_part' | translate}}</p>
            <span>{{ details.bodyPart }}</span>
          </div>
        </div>
      </div>
      <div *ngIf="data.key === 'pathology'" style="margin-top: 15px; margin-bottom: 15px">
        <label class="checkbox" nz-checkbox formControlName="underTherapy">{{ 'medicalHistory.medicalNewRecordModal.under_therapy' | translate}}</label>
      </div>
    </div>
    <div class="allergen" *ngIf="data.key === 'allergen'">
      <div nz-row class="drug-margin">
        <ds-select
          nz-col
          nzXs="24"
          nzSm="24"
          nzMd="12"
          nzLg="12"
          nzXl="12"
          [placeholder]="'medicalHistory.medicalNewRecordModal.choose' | translate"
          [label]="'medicalHistory.medicalNewRecordModal.' + data.key | translate | titlecase"
          [texts]="modalOptions.texts"
          [values]="modalOptions.values"
          [control]="formModal.get('option')"
        ></ds-select>
      </div>
      <div nz-row class="drug-margin">
        <ds-select
          nz-col
          nzXs="24"
          nzSm="24"
          nzMd="12"
          nzLg="12"
          nzXl="12"
          [placeholder]="'medicalHistory.medicalNewRecordModal.choose' | translate"
          [label]="'medicalHistory.medicalNewRecordModal.specificAllergen' | translate"
          [texts]="specificAllergenOptions.texts"
          [values]="specificAllergenOptions.values"
          [control]="formModal.get('specificAllergen')"
        ></ds-select>
      </div>
    </div>
    <div class="vaccination" *ngIf="data.key === 'vaccination'">
      <div nz-row class="drug-margin">
        <ds-select
          nz-col
          nzXs="24"
          nzSm="24"
          nzMd="12"
          nzLg="12"
          nzXl="12"
          [placeholder]="'medicalHistory.medicalNewRecordModal.choose' | translate"
          [label]="'medicalHistory.medicalNewRecordModal.vaccinazione' | translate"
          [texts]="modalOptions.texts"
          [values]="modalOptions.values"
          [control]="formModal.get('option')"
        ></ds-select>
      </div>
      <ds-datepicker
        *ngIf="formModal.get('date')"
        class="drug-margin date-vaccination"
        [label]="'medicalHistory.medicalNewRecordModal.date' | translate"
        nz-col
        nzXs="24"
        nzSm="24"
        nzMd="24"
        nzLg="24"
        nzXl="24"
        [control]="formModal.get('date')"
        [startDate]="leaveYears(todayDate)"
        [endDate]="todayDate"
        [placeholder]=""
      ></ds-datepicker>
      <div style="margin-top: 20px" class="drug-margin">
        <label class="checkbox" nz-checkbox formControlName="revaccination"> {{ 'medicalHistory.medicalNewRecordModal.booster' | translate}} </label>
      </div>
      <ds-datepicker
        [label]="'medicalHistory.medicalNewRecordModal.booster_date' | translate"
        nz-col
        nzXs="24"
        nzSm="24"
        nzMd="12"
        nzLg="12"
        nzXl="12"
        [control]="formModal.get('revaccinationDate')"
        [startDate]="addDays(todayDate)"
        [endDate]="addYears(todayDate)"
        [placeholder]=""
      ></ds-datepicker>
    </div>
    <div class="drug" *ngIf="data.key === 'drug'">
      <div nz-row class="drug-margin">
        <ds-select
          nz-col
          nzXs="24"
          nzSm="24"
          nzMd="12"
          nzLg="12"
          nzXl="12"
          [placeholder]="'medicalHistory.medicalNewRecordModal.choose' | translate"
          [label]="'medicalHistory.medicalNewRecordModal.active_ingredient' | translate"
          [texts]="modalOptions.texts"
          [values]="modalOptions.values"
          [control]="formModal.get('option')"
        ></ds-select>
      </div>
      <div nz-row class="drug-margin">
        <ds-select
          nz-col
          nzXs="24"
          nzSm="24"
          nzMd="12"
          nzLg="12"
          nzXl="12"
          [placeholder]="'medicalHistory.medicalNewRecordModal.choose' | translate"
          [label]="'medicalHistory.medicalNewRecordModal.size' | translate"
          [texts]="drugFormats.texts"
          [values]="drugFormats.values"
          [control]="formModal.get('format')"
        ></ds-select>
      </div>
      <div class="drug-margin">
        <div>{{ 'medicalHistory.medicalNewRecordModal.active_ingredient' | translate}}:</div>
        <div style="margin-top: 15px" *ngIf="selectedDrugName">
          <span>{{ selectedDrugName }}</span>
        </div>
        <div style="margin-top: 15px" *ngIf="!selectedDrugName">
          <span>-</span>
        </div>
      </div>
      <div nz-row style="align-items: end" class="drug-margin">
        <ds-input-text class="input-drug" [label]="'medicalHistory.medicalNewRecordModal.dosage' | translate" [control]="formModal.get('posology')" [placeholder]="'medicalHistory.medicalNewRecordModal.write' | translate"></ds-input-text>
        <ds-select
          class="unit"
          nz-col
          nzXs="24"
          nzSm="24"
          nzMd="12"
          nzLg="12"
          nzXl="8"
          [placeholder]="'medicalHistory.medicalNewRecordModal.select_unit' | translate"
          [texts]="['Unità', 'ml', 'Grammi', 'Numero di applicazioni']"
          [values]="['UNITA', 'ML', 'GRAMMI', 'Applicazioni']"
          [control]="formModal.get('unit')"
        ></ds-select>
      </div>
      <div nz-row style="align-items: end" class="drug-margin">
        <ds-select
          class="posologyFrequence"
          [label]="'medicalHistory.medicalNewRecordModal.frequency' | translate"
          nz-col
          nzXs="24"
          nzSm="24"
          nzMd="12"
          nzLg="12"
          nzXl="11"
          [placeholder]="'medicalHistory.medicalNewRecordModal.select_unit' | translate"
          [texts]="['medicalHistory.medicalNewRecordModal.every_x_hours' | translate]"
          [values]="[ 'medicalHistory.medicalNewRecordModal.times' | translate]"
          [control]="formModal.get('posologyFrequence')"
        ></ds-select>
        <ds-select
          class="dose"
          nz-col
          nzXs="24"
          nzSm="24"
          nzMd="12"
          nzLg="12"
          nzXl="13"
          [placeholder]="'1'"
          [texts]="['1', '2', '3', '4', '6', '8', '12', '24', '48', '72']"
          [values]="['1', '2', '3', '4', '6', '8', '12', '24', '48', '72']"
          [control]="formModal.get('dose')"
        ></ds-select>
      </div>
    </div>
    <ds-datepicker
      *ngIf="data.key !== 'drug' && data.key !== 'vaccination'"
      [label]="'medicalHistory.medicalNewRecordModal.date' | translate"
      nz-col
      nzXs="24"
      nzSm="24"
      nzMd="12"
      nzLg="12"
      nzXl="12"
      [control]="formModal.get('date')"
      [startDate]="leaveYears(todayDate)"
      [endDate]="todayDate"
      [placeholder]=""
    ></ds-datepicker>
    <div *ngIf="data.key !== 'vaccination'">
      <p style="color: var(--text);">{{ 'medicalHistory.medicalNewRecordModal.additional_notes' | translate }}</p>
      <ds-input-text [type]="'textarea'" [control]="formModal.get('notes')" [placeholder]="'medicalHistory.medicalNewRecordModal.describe_details' | translate"></ds-input-text>
    </div>
    <div class="button-container">
      <ds-button class="button-exit" [text]="'buttons.exit' | translate" [styleType]="'empty-main'" [width]="'small'" (click)="close()"></ds-button>
      <ds-button class="button-register" [text]="'buttons.regist' | translate" [width]="'small'" (click)="save()" [isDisabled]="formModal.invalid"></ds-button>
    </div>
  </form>
</div>
